import { render, staticRenderFns } from "./ListThirdParties.vue?vue&type=template&id=51e959c0&scoped=true&"
import script from "./ListThirdParties.vue?vue&type=script&lang=js&"
export * from "./ListThirdParties.vue?vue&type=script&lang=js&"
import style0 from "./ListThirdParties.vue?vue&type=style&index=0&id=51e959c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e959c0",
  null
  
)

export default component.exports